import React from 'react';
import styles from './RecordingIndicator.module.css';
import { IoStop } from 'react-icons/io5';

const RecordingIndicator = ({ onStopRecording }) => {
  const handleStop = () => {
    onStopRecording();
  };

  return (
    <div className={styles.recordingIndicator}>
      <div className={styles.dot} />
      <span>Recording</span>
      <button 
        className={styles.stopButton}
        onClick={handleStop}
        title="Stop Recording"
      >
        <IoStop size={16} />
        <span>Stop</span>
      </button>
    </div>
  );
};

export default RecordingIndicator;